import React, { ReactNode } from "react";
import { Layout } from "Components/Layout/Layout";
import { useInRouteDrawer } from "Components/RouteDrawer/RouteDrawerContext";
import SettingsLayout from "../SettingsLayout/SettingsLayout";

export const SettingsPageLayout = ({ children }: { children?: ReactNode }) => {
  const inDrawer = useInRouteDrawer();
  return (
    <Layout>
      {inDrawer ? children : <SettingsLayout>{children}</SettingsLayout>}
    </Layout>
  );
};
